export enum FontWeight {
  SEMIBOLD = 'semibold',
  MEDIUM = 'medium',
}

export enum FontStyle {
  HEADING = 'heading',
  BODY = 'body',
}
